export default __webpack_public_path__ + "static/media/icons-04.9b8174ce.svg";